import React, { useRef, useState, useEffect } from 'react';
import { useAuthDataContext } from '../../../../../_providers/Auth';
import Api from '../../../../../_helpers/Api';
import editIcon from '../../../../../assets/img/icons/edit-yellow.png';
import Modal from './modals/ReservationType';
import Skeleton from 'react-loading-skeleton';
import Options from './ReservationTypesOptions';
import NoDataFound from '../../../../partials/NoDataFound';
import { trans } from '../../../../../_providers/Translation';

function ReservationTypes(props) {

    const auth = useAuthDataContext();

    const modalRef = useRef(null);

    const [state, setState] = useState({
        loading: true,
        data: [],
        update: false,
    });

    useEffect(() => {
        loadSettings();
    }, [state.update]);

    const loadSettings = () => {
        Api.get('reservations/types?partner_id=' + auth.partnerId())
            .then(res => {
                setState(prev => ({
                    ...prev,
                    loading: false,
                    data: res.data
                }));
            }).catch(err => {
                setState(prev => ({
                    ...prev,
                    loading: false
                }));
            });
    }

    const handleAdd = () => {
        let modal = modalRef.current;

        modal.open();

        modal.onSave(data => {
            setState(prev => ({
                ...prev,
                data: prev.data.concat(data)
            }));

            if (typeof props.handleRefresh === 'function') {
                props.handleRefresh();
            }
        });

    }

    const handleEdit = id => {
        let modal = modalRef.current;

        modal.edit(id);

        modal.onSave(data => {
            handleUpdate();

            if (typeof props.handleRefresh === 'function') {
                props.handleRefresh();
            }
        });

    }

    const handleUpdate = () => {
        setState(prev => ({
            ...prev,
            update: new Date().getTime()
        }));
    }

    const handleDelete = id => {
        Api.post('reservations/types/delete', {
            id: id
        }).then(res => {
            if (res.data.success) {
                handleUpdate();
            }
        });
    }

    return (
        <div style={{ width: '100%' }}>
            <Modal
                ref={modalRef}
            />

            <div className="head">
                <h4>{trans('headings.reservationTypes')}</h4>

                <button
                    className="button button-add button-small"
                    onClick={handleAdd}
                >
                    {trans('buttons.add')}
                </button>
            </div>

            {state.loading
                ?
                <Skeleton height={35} count={10} />
                :
                <>
                    {state.data.length === 0
                        ?
                        <NoDataFound />
                        :
                        <div className="table-scroller">
                            <table className="settings">
                                <thead>
                                    <tr>
                                        <td>
                                            {trans('labels.name')}
                                        </td>
                                        <td>
                                            {trans('labels.reservationTypeExecTime')}
                                        </td>
                                        <td className="options center">
                                            {trans('labels.options')}
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {state.data.map(t =>
                                        <tr key={t.id}>
                                            <td>
                                                {t.name}
                                            </td>
                                            <td>
                                                {t.minutes}
                                            </td>
                                            <td className="options center">
                                                <Options
                                                    id={t.id}
                                                    handleEdit={handleEdit}
                                                    handleDelete={handleDelete}
                                                />
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    }
                </>
            }
        </div>
    )

}

export default ReservationTypes